package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.InvitationListPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationListPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationInvitationListPresenterFactory {
  @Provides
  @IntoSet
  public fun provideInvitationListPresenterFactoryFactoryMultibinding(invitationListPresenterFactory: InvitationListPresenterFactory): Presenter.Factory = invitationListPresenterFactory
}
